export default __webpack_public_path__ + "static/main-cup-red-0f62c7bfe788b172bfeb1d486eee2290.png";